<template>
  <div class="orderdetail">
    <div class="icpdemandLoading" v-show="loading" v-loading="true"></div>
    <div class="orderdetailTitle">
      <div class="orderdetailTitle-wrap">
        <el-breadcrumb separator="|">
          <el-breadcrumb-item :to="{ path: '/icpmyorder/purchased' }"
            ><i class="el-icon-arrow-left"></i> 返回</el-breadcrumb-item
          >
          <el-breadcrumb-item>服务单详情</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- <el-page-header content="详情页面"> </el-page-header> -->
        <div class="orderdetailTitle-wrap-button">
          <el-button
            class="nobgbutton"
            @click="
              dialogVisible = true;
              dialogTitle = '关闭服务单';
            "
            >关闭服务单</el-button
          >
          <el-button
            class="bgbutton"
            @click="
              dialogVisible = true;
              dialogTitle = '修改服务状态';
            "
            >变更状态</el-button
          >
          <el-button
            class="bgbutton"
            v-if="activedIndex >= 4"
            @click="handleGoFillDetail"
            >材料详情</el-button
          >
          <el-button
            class="bgbutton"
            v-if="detailData.solutionContent.status == 'CLOSE'"
            @click="
              dialogVisible = true;
              dialogTitle = '关闭原因';
            "
            >关闭原因</el-button
          >
          <el-button class="bgbutton" v-if="activedIndex <= 2" @click="gotofill"
            >填写材料</el-button
          >
        </div>
      </div>
    </div>
    <div class="orderdetailMain">
      <div class="orderdetailMain-title">
        <div class="leftShu"></div>
        <span>服务流程</span>
      </div>
      <div class="orderdetailMain-step">
        <div class="steps" v-for="(item, index) in stepList" :key="index">
          <h1
            v-if="activedIndex <= index + 1"
            :class="activedIndex == index + 1 ? 'pedding' : ''"
          >
            {{ index + 1 }}
          </h1>
          <h2 v-else class="finish"><i :class="item.icon"></i></h2>
          <p class="line" v-show="index != 0"></p>
          <h3>
            {{ item.title }}
          </h3>
          <h4>
            {{ item.msg }}
          </h4>
        </div>
      </div>
      <div class="orderdetailMain-title">
        <div class="leftShu"></div>
        <span>服务概览</span>
      </div>
      <div class="orderdetailMain-detail">
        <ul>
          <li>
            服务/需求单号：<span>{{ detailData.needNo }}</span>
          </li>
          <li>
            方案编号：<span>{{ detailData.solutionNo }}</span>
          </li>
          <li>
            状态：<span>{{ detailData.statusName }}</span>
          </li>
          <li>
            服务类型：<span>{{ detailData.solutionContent.typeName }}</span>
          </li>
          <li>
            企业名称：<span>{{
              detailData.solutionContent.solution.CompanyName
            }}</span>
          </li>
          <li>
            联系人：<span>{{ detailData.needinfo.publishName }}</span>
          </li>
          <li>
            联系电话：<span>{{ detailData.needinfo.publishMobile }}</span>
          </li>
          <li>
            注册账号：<span>{{ detailData.needinfo.channelUserId }}</span>
          </li>
        </ul>
      </div>
      <!-- <div class="orderdetailMain-title">
        <div class="leftShu"></div>
        <span>物流信息</span>
      </div> -->
      <!-- <div class="orderdetailMain-detail">
        <ul>
          <li>
            用户快递单号：<el-input
              disabled
              v-model="value"
              placeholder="请输入内容"
            ></el-input
            ><el-button plain><i class="el-icon-edit"></i>修改</el-button>
          </li>
          <li>回寄用户运单号：<span>24679009878749021</span></li>
          <li></li>
          <li>邮寄地址：<span>北京市朝阳区创园路36号院10号楼102</span></li>
        </ul>
      </div> -->
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="700px"
      >
        <closePlan
          v-if="dialogTitle == '关闭服务单'"
          @tolkParent="tolkParent"
        />
        <changeFile
          v-if="dialogTitle == '修改服务状态'"
          @tolkParent="tolkParent"
        />
        <closeReason v-if="dialogTitle == '关闭原因'" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getNeedSolutionDetailByUser } from '@/api/alicp.js';
import changeFile from './component/changeFile';
import closePlan from './component/closePlan';
import closeReason from './component/closeReason';
export default {
  components: {
    changeFile,
    closePlan,
    closeReason,
  },
  data() {
    return {
      loading: false,
      dialogTitle: '',
      dialogVisible: false,
      stepList: [
        {
          title: '提交服务单',
          msg: '',
          icon: 'el-icon-check',
        },
        {
          title: '等待我处理',
          msg: '收集并上传材料',
          icon: 'el-icon-check',
        },
        {
          title: '等待客户处理',
          msg: '联系客户确认材料',
          icon: 'el-icon-check',
        },
        {
          title: '等待我处理',
          msg: '待提交工信部系统',
          icon: 'el-icon-check',
        },
        {
          title: '工信部受理中',
          msg: '需要更改受理状态',
          icon: 'el-icon-check',
        },
        {
          title: '等待我处理',
          msg: '领取证书',
          icon: 'el-icon-check',
        },
        {
          title: '服务完成',
          msg: '证件邮寄客户服务完成',
          icon: 'el-icon-check',
        },
      ],
      detailData: {
        id: null,
        channelNeedNo: '', //渠道需求号
        needNo: '', //需求号
        solutionNo: '', //方案号
        channelSolutionNo: '', //渠道方案号 同BizId
        orderNo: null, //服务订单号
        needinfo: {
          //需求信息 ---- 联系人信息
          publishName: '',
          publishMobile: '',
          channelUserId: '',
        },
        solutionContent: {
          //方案交付信息
          notes: '', //用户反馈备注
          status: '', //方案流程状态
          bizType: '', //操作类型
          material: {
            //材料信息
            Domain: '',
            PartnerLaw: '',
            PartnerPlan: '',
            CorporateName: '',
            PartnerIdCardList: [''],
            PartnerSignOtherList: [''],
            PartnerStampOtherList: [''],
            PartnerBusinessLicense: '',
            PartnerPreviewOtherList: [''],
            IncludeForeignInvestment: true,
            PartnerDomainCertificate: '',
            PartnerForeignInvestment: '',
            PartnerSignAndStampOtherList: [''],
          },
          solution: {
            //方案信息
            Area: '',
            Note: '',
            IcpType: '',
            CompanyName: '',
            CompanyAddress: '',
          },
          totalSum: '', //订单金额
          typeCode: '', //产品码
          typeName: '', //产品名称
          statusName: '', //流程状态名称
          solutionFlowList: [
            //方案流程列表
          ],
          applicationStatusList: [
            //方案通知状态列表 ---- 未用到
          ],
        },
        status: '', //方案状态
        statusName: '', //方案状态
        createUserId: null,
        created_at: '',
        updated_at: '',
        deleted_at: null,
        version: 0,
      },
      activedIndex: 0,
      value: '',
      icpSolutionStatusReference: {
        SOLUTION_SUBMIT: '提交服务单',
        UN_PAID: '未支付',
        PAID: '用户支付',
        //0
        USER_UPLOADED: '基本材料已上传',
        //1
        MATERIAL_UNCONFIRM: '收集并上传材料',
        //2
        USER_CONFIRMED: '客户确认材料',
        //3
        MATERIAL_SUBMITTED: '提交工信部系统',
        //4
        GXB_ACCEPT: '工信部已受理',
        GXB_REFUSE: '工信部不予受理',
        GXB_FAIL: '工信部未通过',
        //5
        GXB_SUCCESS: '工信部通过',
        //6
        ACCOUNT_REGISTERED: '完成账户注册',
        CLOSE: '方案关闭',
        //7
      },
    };
  },
  mounted() {
    this.getdetail();
  },
  methods: {
    //getdetail
    getdetail() {
      let params = this.$route.query.solutionNo;
      this.loading = true;
      getNeedSolutionDetailByUser(params).then((res) => {
        this.loading = false;
        // console.log(res.data);
        if (res.status == 0) {
          this.detailData = res.data;
          this.changeActivedIndex(res.data.solutionContent.status);
          this.stepList[0].msg = this.timer(res.data.created_at);
          // this.stepList[this.activedIndex - 1].title =
          //   res.data.solutionContent.statusName;
        } else {
          this.$message.warning('刷新页面重试！');
        }
      });
    },
    //timer
    timer(time) {
      var d = new Date(time);
      var year = d.getFullYear(); //年
      var month = d.getMonth() + 1; //月
      var day = d.getDate(); //日
      var hh = d.getHours(); //时
      var mm = d.getMinutes(); //分
      var ss = d.getSeconds(); //秒
      var clock = year + '/';
      if (month < 10) clock += '0';
      clock += month + '/';
      if (day < 10) clock += '0';
      clock += day + ' ';
      if (hh < 10) clock += '0';
      clock += hh + ':';
      if (mm < 10) clock += '0';
      clock += mm + ':';
      if (ss < 10) clock += '0';
      clock += ss;
      return clock;
    },
    //跳转填写材料页面
    gotofill() {
      this.$router.push({
        path: 'alicpfillmaterials/applicantInfo',
        query: {
          BizId: this.detailData.channelSolutionNo,
          url: '/icporderdetail',
          query: JSON.stringify(this.$route.query),
        },
      });
    },
    changeActivedIndex(type) {
      switch (type) {
        case 'SOLUTION_SUBMIT':
          this.activedIndex = 0;
          break;
        case 'UN_PAID':
          this.activedIndex = 0;
          break;
        case 'PAID':
          this.activedIndex = 0;
          break;
        case 'USER_UPLOADED':
          this.activedIndex = 1;
          break;
        case 'MATERIAL_UNCONFIRM':
          this.activedIndex = 2;
          break;
        case 'USER_CONFIRMED':
          this.activedIndex = 3;
          break;
        case 'MATERIAL_SUBMITTED':
          this.activedIndex = 4;
          break;
        case 'GXB_ACCEPT':
          this.activedIndex = 5;
          break;
        case 'GXB_REFUSE':
          this.activedIndex = 5;
          break;
        case 'GXB_FAIL':
          this.activedIndex = 5;
          break;
        case 'GXB_SUCCESS':
          this.activedIndex = 6;
          break;
        case 'ACCOUNT_REGISTERED':
          this.activedIndex = 7;
          break;
        case 'CLOSE':
          this.activedIndex = 7;
          break;
      }
    },
    //
    handleGoFillDetail() {
      this.$router.push({
        path: '/icpmaterialdetails',
        query: { ...this.$route.query },
      });
    },
    tolkParent(params) {
      // console.log(params);
      this.loading = params.loading;
      this.dialogVisible = params.dialog;
      this.getdetail();
    },
  },
};
</script>

<style lang="scss">
.orderdetail {
  width: 100%;
  background: #f5f5f6;
  padding-bottom: 45px;
  .orderdetailTitle {
    width: 100%;
    padding: 19px 0;
    margin-bottom: 20px;
    background: #fff;
    .orderdetailTitle-wrap {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .el-page-header {
        line-height: 40px;
      }
      .orderdetailTitle-wrap-button {
        .nobgbutton {
          color: #ff6a00;
          border-color: #ff6a00;
          background: #fff;
        }
        .nobgbutton:hover,
        .nobgbutton:focus {
          color: #ff6a00;
          border-color: #ff6a00;
          background: #fff;
        }
        .bgbutton {
          background: #ff6a00;
          color: #fff;
          border-color: #ff6a00;
        }
      }
      .el-breadcrumb__item {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 22px;
      }
      .is-link {
        color: #ff6a00;
      }
    }
  }
  .orderdetailMain {
    width: 1200px;
    background: #fff;
    margin: 0 auto;
    padding: 30px;
  }
  .icpdemandLoading {
    width: 100%;
    height: 100%;
    position: fixed !important;
    top: 0;
    left: 0;
    z-index: 9999;
  }
}
.orderdetailMain-title {
  width: 100%;
  display: flex;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(38, 38, 38, 1);
  line-height: 22px;
  letter-spacing: 1px;
  align-items: center;
  .leftShu {
    width: 3px;
    height: 16px;
    background: rgba(254, 106, 1, 1);
    margin-right: 10px;
  }
}
.orderdetailMain-step {
  display: flex;
  padding: 30px 0;
  margin-bottom: 20px;
  .steps {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    h1,
    h2 {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100px;
      border: 1px solid rgba(0, 0, 0, 0.25);
      font-size: 16px;
      font-family: HelveticaNeue;
      color: rgba(0, 0, 0, 0.25);
      line-height: 24px;
      margin-bottom: 12px;
    }
    .finish {
      border: 1px solid #fe6a01;
      color: #fe6a01;
    }
    .pedding {
      background: #fe6a01;
      color: #fff;
      border: 1px solid #fe6a01;
    }
    .line {
      width: 112px;
      height: 1px;
      background: #e9e9e9;
      position: absolute;
      top: 16px;
      left: -56px;
    }
    h3 {
      font-size: 16px;
      font-family: HelveticaNeue;
      color: rgba(0, 0, 0, 0.85);
      line-height: 24px;
      margin-bottom: 3px;
    }
    h4 {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
      line-height: 22px;
    }
  }
}
.orderdetailMain-detail {
  width: 100%;
  padding: 30px;
  ul {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    li {
      width: 33.3%;
      padding-left: 50px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
      line-height: 22px;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        line-height: 22px;
      }
      .el-input {
        width: 147px;
        height: 32px;
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        input {
          width: 100%;
          height: 100%;
          border: none;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.25);
          line-height: 22px;
        }
      }
      .el-button {
        width: 54px;
        height: 32px;
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;
        border: 1px solid #fe6a01;
        padding: 0;
        margin-left: 5px;
        span {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(254, 106, 1, 1);
          line-height: 17px;
        }
      }
      .el-button.is-plain:hover,
      .el-button.is-plain:focus {
        border-color: #fe6a01;
        color: #fe6a01;
      }
    }
    li:nth-child(3n + 1) {
      padding-left: 0;
    }
  }
}
</style>
